// API基础配置
import axios from 'axios'

// 根据环境动态配置API
const getBaseURL = () => {
  // 如果设置了环境变量，优先使用环境变量
  if (process.env.VUE_APP_API_BASE_URL) {
    return process.env.VUE_APP_API_BASE_URL
  }

  // 开发环境：使用代理路径避免CORS问题
  if (process.env.NODE_ENV === 'development') {
    return '/api'
  }

  // 生产环境：使用相对路径，通过nginx代理
  if (process.env.NODE_ENV === 'production') {
    return '/api'
  }

  // 兜底配置：直接访问后端（可能有CORS问题）
  return 'http://10.105.0.33:20001/api'
}

// API配置
export const API_CONFIG = {
  BASE_URL: getBaseURL(),
  TIMEOUT: 10000 // 增加到30秒，避免超时
}

// 创建axios实例
const apiClient = axios.create({
  baseURL: API_CONFIG.BASE_URL,
  timeout: API_CONFIG.TIMEOUT,
  // 直接对接后端，使用基本配置
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  },
  // 直接对接后端，不需要withCredentials
  withCredentials: false,
  // 添加重试配置
  retry: 3,
  retryDelay: 1000
})

// 请求拦截器
apiClient.interceptors.request.use(
  (config) => {
    // 从localStorage获取token
    const token = localStorage.getItem('cbti_token')
    if (token) {
      // 根据接口文档，使用Authorization头部
      config.headers.Authorization = token
    }

    // 对于登录接口，添加接口文档中指定的Authorization头
    if (config.url === '/user/login') {
      config.headers.Authorization = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJjbGFpbXMiOnsicGhvbmUiOiIxNDQ3ODU4OTY1OSIsImlkIjoyfSwiZXhwIjoxNzUxNzkwOTczfQ.2y0LbxKtwtT-ykEjNLf4FrBLSKbSbCrPReRCK0OL64c'
    }

    // 对于需要认证的接口，如果没有token则使用示例token
    const needsAuthUrls = [
      '/checkin-advices/',
      '/doctor/patient/',
      '/doctor/dashboard/',
      '/medical-order-record/',
      '/sleep-prescription/',
      '/scale/',
      '/sleep-diary/',
      '/mood-record/',
      '/thanksgiving-record/',
      '/worry-record/',
      '/other-state-record/',
      '/user/changePassword',
      '/user/doctor/generateQRCode',
      '/user/register-patient',
      '/user/sms/sendResetCode',
      '/user/resetPasswordBySms',
      '/patient-scheme/',
      '/follow-up-record/',
      '/science-popularization-material/',
      '/training-task/'
    ]
    const needsAuth = needsAuthUrls.some(url => config.url?.includes(url))

    if (needsAuth && !token) {
      console.log('使用默认token进行请求认证')
      config.headers.Authorization = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJjbGFpbXMiOnsicGhvbmUiOiIxNDQ3ODU4OTY1OSIsImlkIjoyfSwiZXhwIjoxNzUxNzkwOTczfQ.2y0LbxKtwtT-ykEjNLf4FrBLSKbSbCrPReRCK0OL64c'
    }

    // 对于GET请求，如果配置了data参数，需要特殊处理以支持Body参数
    // 特别是 /checkin-advices/doctor-patients-checkin/page 接口需要Body参数
    if (config.method === 'get' && config.data) {
      // 确保Content-Type正确设置
      if (!config.headers['Content-Type']) {
        config.headers['Content-Type'] = 'application/json'
      }
      // axios 会自动序列化对象，不需要手动 JSON.stringify
      // 但需要确保使用 transformRequest 或者直接传递对象
    }

    console.log('发送请求:', config.method?.toUpperCase(), config.url)
    console.log('请求参数:', config.params)
    console.log('请求Body:', config.data)
    console.log('请求头:', config.headers)
    console.log('当前token:', config.headers.Authorization ? '已设置' : '未设置')
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// 响应拦截器
apiClient.interceptors.response.use(
  (response) => {
    return response
  },
  async (error) => {
    // 处理401未授权错误
    if (error.response?.status === 401) {
      // 清除本地存储的用户信息和token
      localStorage.removeItem('cbti_user')
      localStorage.removeItem('cbti_token')

      // 跳转到登录页面
      if (window.location.pathname !== '/login') {
        window.location.href = '/login'
      }
    }

    // 处理超时和网络错误，进行重试
    if (error.code === 'ECONNABORTED' || error.message.includes('timeout') || !error.response) {
      const config = error.config

      // 检查是否已经重试过
      if (!config.__retryCount) {
        config.__retryCount = 0
      }

      // 检查重试次数
      if (config.__retryCount < (config.retry || 3)) {
        config.__retryCount += 1

        console.log(`请求超时，正在进行第 ${config.__retryCount} 次重试...`)

        // 等待重试延迟
        await new Promise(resolve => setTimeout(resolve, config.retryDelay || 1000))

        // 重新发送请求
        return apiClient(config)
      }
    }

    return Promise.reject(error)
  }
)

export default apiClient
